import { render, staticRenderFns } from "./ProjectDetailsPage.vue?vue&type=template&id=bd5ef99a&scoped=true"
import script from "./ProjectDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailsPage.vue?vue&type=style&index=0&id=bd5ef99a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5ef99a",
  null
  
)

export default component.exports